import React from 'react';
import './App.css'; // Assuming you have a CSS file for styling

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src="walnut-place-management-company-high-resolution-logo.png" className="App-logo" alt="logo" />
        <p>
          Coming Summer 2024
        </p>
      </header>
    </div>
  );
}

export default App;
